import publicBookingConfirmationTemplate from '../_templates/steps/confirmation.html';

import publicBookingCalendarTemplate from '../_templates/steps/calendar.html';

import publicBookingClientTemplate from '../_templates/steps/client.html';

import publicBookingCheckItemsTemplate from '../_templates/steps/check_items.html';

import '../../member/_templates/steps/register.html';
import companyListTemplate from '../../public-booking/_templates/steps/company_list.html';
import eventListTemplate from '../../public-booking/_templates/steps/event_list.html';
import eventTemplate from '../../public-booking/_templates/steps/event.html';
import serviceListTemplate from '../../public-booking/_templates/steps/service_list.html';
import resourceListTemplate from '../../public-booking/_templates/steps/resource_list.html';
import personListTemplate from '../../public-booking/_templates/steps/person_list.html';
import durationListTemplate from '../../public-booking/_templates/steps/duration_list.html';
import timeTemplate from '../../public-booking/_templates/steps/time.html';
import checkMoveTemplate from '../../public-booking/_templates/steps/check_move.html';
import purchaseTemplate from '../../public-booking/_templates/steps/purchase.html';
import basketSummaryTemplate from '../../public-booking/_templates/steps/basket_summary.html';
import checkoutTemplate from '../../public-booking/_templates/steps/checkout.html';
import basketTemplate from '../../public-booking/_templates/steps/basket.html';

angular.module('BBPublicBooking').service('bbWidgetPage', BBWidgetPage);

function BBWidgetPage(AlertService, BBModel, LoadingService, LoginService, $rootScope, $sce, bbWidgetRoutes) {

    let $scope = null;

    let isAdminBookingLoaded = false;
    try {
        angular.module('BBAdminBooking');
        isAdminBookingLoaded = true;
    } catch (err) {
    }

    // Automatic Decide Next Page: this flag can be used for pages
    // which require to prevent the widget's built-in decide next page
    let automaticDNP = {};

    const setScope = function ($s) {
        $scope = $s;
    };
    const guardScope = function () {
        if ($scope === null) {
            throw new Error('please set scope');
        }
    };
    const clearPage = function () {
        guardScope();
        return $scope.bb_main = '';
    };
    const hidePage = function () {
        guardScope();
        return $scope.hide_page = true;
    };
    const jumpToPage = function (route) {
        guardScope();
        $scope.current_page = route;
        $scope.jumped = true;
        /*
                 Apply the revised page name according to it's given version
                 */
        const revisedPage = (bbWidgetRoutes.routes && bbWidgetRoutes.routes[route]) ? bbWidgetRoutes.routes[route].revisedPage : route;
        return $scope.bb_main = $sce.trustAsResourceUrl($scope.partial_url + revisedPage + $scope.page_suffix);
    };
    const setLoadingPage = function (val) {
        guardScope();
        return $scope.loading_page = val;
    };
    const isLoadingPage = function () {
        guardScope();
        return $scope.loading_page;
    };
    const setPageRoute = function (route) {
        guardScope();
        $scope.bb.current_page_route = route;
        if ($scope.bb.routeSteps && $scope.bb.routeSteps[route]) {
            showPage($scope.bb.routeSteps[route]);
            return true;
        }
        return false;
    };
    const showPage = (route, dont_record_page) => {
        route = route.replace('.html', '');
        guardScope();
        $scope.bb.updateRoute(route);
        $scope.jumped = false;
        if (isLoadingPage()) {
            return;
        }
        setLoadingPage(true);
        /*
                 Apply the revised page name according to it's given version
                 */
        const revisedPage = (bbWidgetRoutes.routes && bbWidgetRoutes.routes[route]) ? bbWidgetRoutes.routes[route].revisedPage : route;
        if ($scope.bb.current_page === route) {
            $scope.bb_main = '';
            setTimeout(() => {
                $scope.bb_main = $sce.trustAsResourceUrl($scope.bb.pageURL(revisedPage));
                return $scope.$apply();
            }, 0);
        } else {
            AlertService.clear();
            $scope.bb.current_page = route;
            if (!dont_record_page) {
                $scope.bb.recordCurrentPage();
            }
            LoadingService.notLoaded($scope);
            $scope.bb_main = $sce.trustAsResourceUrl($scope.bb.pageURL(revisedPage));
        }

        // reset this collection on each page change
        automaticDNP = {};

        return $rootScope.$broadcast('page:loaded');
    };
    const setPageLoaded = function () {
        return LoadingService.setLoaded($scope);
    };
    const decideNextPage = function (route) {
        guardScope();
        if (route) {
            if (route === 'none') return;

            if ($scope.bb.total && $scope.bb.payment_status === 'complete') {
                if (setPageRoute($rootScope.Route.Confirmation)) return;

                if (isAdminBookingLoaded) showPage(adminBookingConfirmationTemplate.id);
                else showPage(publicBookingConfirmationTemplate.id);
            } else {
                showPage(route);
            }
            return;
        }

        if ($scope.bb.nextSteps && $scope.bb.current_page && $scope.bb.nextSteps[$scope.bb.current_page] && !$scope.bb.routeSteps) {
            showPage($scope.bb.nextSteps[$scope.bb.current_page]);
            return;
        }


        

        /**
         * Sometimes the client.valid method results to be not defined,
         * so we need to mock it in order to avoid failures.
         *
         * If the function is not defined, let's define it and check if we are moving
         * a booking in order to return the right value
         */
        if (!$scope.client.valid) {
            $scope.client.valid = () => $scope.bb.moving_booking !== undefined;
        }

        if (!$scope.client.valid() && LoginService.isLoggedIn()) {
            $scope.client = new BBModel.Client(LoginService.member()._data);
        }

        if (($scope.bb.company && $scope.bb.company.companies) || (!$scope.bb.company && $scope.affiliate)) {
            if (setPageRoute($rootScope.Route.Company)) return;

            showPage(companyListTemplate.id);

        } else if ($scope.bb.total && $scope.bb.payment_status === 'complete') {
            if (setPageRoute($rootScope.Route.Confirmation)) return;

            if (isAdminBookingLoaded) showPage(adminBookingConfirmationTemplate.id);
            else showPage(publicBookingConfirmationTemplate.id);

        } else if ($scope.bb.total && $scope.bb.payment_status === 'pending') {
            showPage(paymentTemplate.id);

        } else if (($scope.bb.company.$has('event_groups') && !$scope.bb.current_item.event_group && !$scope.bb.current_item.service && !$scope.bb.current_item.product && !$scope.bb.current_item.deal) || ($scope.bb.company.$has('events') && $scope.bb.current_item.event_group && ($scope.bb.current_item.event == null) && !$scope.bb.current_item.product && !$scope.bb.current_item.deal)) {
            if (setPageRoute($rootScope.Route.Event)) return;

            showPage(eventListTemplate.id);

        } else if ($scope.bb.company.$has('events') && $scope.bb.current_item.event && !$scope.bb.current_item.num_book && (!$scope.bb.current_item.tickets || !$scope.bb.current_item.tickets.qty) && !$scope.bb.current_item.product && !$scope.bb.current_item.deal) {
            showPage(eventTemplate.id);

        } else if ($scope.bb.company.$has('services') && !$scope.bb.current_item.service && ($scope.bb.current_item.event == null) && !$scope.bb.current_item.product && !$scope.bb.current_item.deal) {
            if (setPageRoute($rootScope.Route.Service)) return;

            showPage(serviceListTemplate.id);

        } else if ($scope.bb.company.$has('resources') && !$scope.bb.current_item.resource && ($scope.bb.current_item.event == null) && !$scope.bb.current_item.product && !$scope.bb.current_item.deal) {
            if (setPageRoute($rootScope.Route.Resource)) return;

            showPage(resourceListTemplate.id);

        } else if ($scope.bb.company.$has('people') && !$scope.bb.current_item.person && ($scope.bb.current_item.event == null) && !$scope.bb.current_item.product && !$scope.bb.current_item.deal) {
            if (setPageRoute($rootScope.Route.Person)) return;

            showPage(personListTemplate.id);

        } else if (!$scope.bb.current_item.duration && ($scope.bb.current_item.event == null) && !$scope.bb.current_item.product && !$scope.bb.current_item.deal) {
            if (setPageRoute($rootScope.Route.Duration)) return;

            showPage(durationListTemplate.id);

        } else if (($scope.bb.moving_booking && !$scope.bb.current_item.date) || ($scope.bb.current_item.days_link && !$scope.bb.current_item.date && ($scope.bb.current_item.event == null) && !$scope.bb.current_item.deal)) {
            // if it is move booking, try to go to the calendar

            if ($scope.bb.company.$has('availability_slots')) {
                if (setPageRoute($rootScope.Route.Slot)) return;

                showPage('slot_list'); //TODO this template does not exists
            } else {
                if (setPageRoute($rootScope.Route.Date)) return;

                if (isAdminBookingLoaded) showPage(adminBookingCalendarTemplate.calendarPageTemplateUrl);
                else showPage(publicBookingCalendarTemplate.id);
            }

        } else if ($scope.bb.current_item.days_link && !$scope.bb.current_item.time && ($scope.bb.current_item.event == null) && (!$scope.bb.current_item.service || $scope.bb.current_item.service.duration_unit !== 'day') && !$scope.bb.current_item.deal) {
            if (setPageRoute($rootScope.Route.Time)) return;

            showPage(timeTemplate.id);

        } else if ($scope.bb.moving_booking && (!$scope.bb.current_item.ready || !$scope.bb.current_item.move_done)) {
            showPage(checkMoveTemplate.id);

        } else if (!$scope.client.valid()) {
            if (setPageRoute($rootScope.Route.Client)) return;

            if (isAdminBookingLoaded) showPage(adminBookingClientTemplate.id);
            else showPage(publicBookingClientTemplate.id);

        } else if ($scope.bb.current_item.item_details && $scope.bb.current_item.item_details.hasQuestions && !$scope.bb.current_item.asked_questions) {
            if (setPageRoute($rootScope.Route.Questions)) return;

            if (isAdminBookingLoaded) showPage(adminBookingCheckItemsTemplate.id);
            else showPage(publicBookingCheckItemsTemplate.id);

        } else if ($scope.bb.moving_booking && $scope.bb.basket.itemsReady()) {
            showPage(purchaseTemplate.id);

        } else if (!$scope.bb.basket.readyToCheckout()) {
            if (setPageRoute($rootScope.Route.Summary)) return;

            showPage(basketSummaryTemplate.id);

        } else if ($scope.bb.usingBasket && (!$scope.bb.confirmCheckout || $scope.bb.company_settings.has_vouchers || $scope.bb.company.$has('coupon'))) {
            if (setPageRoute($rootScope.Route.Basket)) return;

            showPage(basketTemplate.id);
        } else if ($scope.bb.basket.readyToCheckout() && $scope.bb.payment_status === null && !$scope.bb.basket.waiting_for_checkout) {
            if (setPageRoute($rootScope.Route.Checkout)) return;

            showPage(checkoutTemplate.id);

        } else if ($scope.bb.payment_status === 'complete') {
            if (setPageRoute($rootScope.Route.Confirmation)) return;

            if (isAdminBookingLoaded) showPage(adminBookingConfirmationTemplate.id);
            else showPage(publicBookingConfirmationTemplate.id);

        }
    };

    const canAutoDecideNextPage = (widget) => {
        return automaticDNP.hasOwnProperty(widget) ? automaticDNP[widget] : true;
    };

    const setAutoDecideNextPage = (widget, state = false) => {
        automaticDNP[widget] = state;
    };

    return {
        clearPage,
        decideNextPage,
        hidePage,
        isLoadingPage,
        jumpToPage,
        setLoadingPage,
        setPageLoaded,
        setPageRoute,
        setScope,
        showPage,
        canAutoDecideNextPage,
        setAutoDecideNextPage
    };
}



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/widget/bb_widget_page.service.js